import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import {
	SimpleAutoCompleteSearchField,
	ISimpleAutoCompleteSearchFieldItemSelectionEvent,
} from '../../../autocomplete/SimpleAutoCompleteSearchField';
import { SearchIcon } from '../../../svgs/icons/SearchIcon';
import { styleSheet } from '../../../dataBoards/SearchComponent/styles';

interface IProps {
	className?: string;
	onClear: () => void;
	onTagSelected: (tag: Api.IAccountTag) => void;
	selectedTag: Api.IAccountTag | null;
	inputStyle?: any;
}

export const DonationTagSearch = ({ className, onClear, onTagSelected, selectedTag, inputStyle }: IProps) => {
	const userSession = useUserSession();
	const [searchValue, setSearchValue] = React.useState('');

	const handleItemSelected = (e: ISimpleAutoCompleteSearchFieldItemSelectionEvent) => {
		if (e.selection) {
			// Type assertion is safe here because we know the autocomplete type is AccountTag
			const tag = e.selection as Api.IAccountTag;
			onTagSelected(tag);
			setSearchValue(tag.name);
			if (e.target) {
				e.target.setSearchQuery(tag.name);
			}
		}
	};

	const handleClear = () => {
		setSearchValue('');
		onClear();
	};

	React.useEffect(() => {
		if (selectedTag) {
			setSearchValue(selectedTag.name);
		} else {
			setSearchValue('');
		}
	}, [selectedTag]);

	return (
		<SimpleAutoCompleteSearchField
			id='donation-tag-search'
			onItemSelected={handleItemSelected}
			onClear={handleClear}
			placeholder='Search'
			initialSearchQuery={searchValue}
			type={Api.ResourceAutoCompleteViewModelType.AccountTag}
			// userSession is required by AutoCompleteSearchField but not properly typed in SimpleAutoCompleteSearchField's interface
			{...({ userSession } as any)}
			leftAccessory={<SearchIcon className={css(styleSheet.searchIcon)} />}
			style={inputStyle || className}
		/>
	);
};
